"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var react_1 = __importStar(require("react"));
var Popper_1 = __importDefault(require("@material-ui/core/Popper"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var icons_1 = require("../icons");
var Input_1 = require("../inputs/Input");
var Calendar_1 = require("./Calendar");
var hooks_1 = require("./hooks");
var styles_1 = require("./styles");
var utils_2 = require("./utils");
var useStyles = (0, system_1.makeStyles)(function (theme) { return (__assign({ input: {
        width: 'inherit',
    }, dateInput: {
        width: 136,
    }, calendarsGroup: {
        display: 'flex',
    }, inputsGroup: {
        display: 'flex',
    }, dash: {
        margin: '0 8px',
        height: 40,
        display: 'inline-flex',
        alignItems: 'center',
    } }, (0, styles_1.commonStyles)(theme.go))); }, { name: 'GoDateRangePicker' });
var useCalendarStyles = (0, system_1.makeStyles)(function () { return ({
    root: {
        '& + &': {
            marginLeft: 16,
        },
    },
}); });
function useMainValue(value, inputValue, timeInputValue, inputDateFormat, mainInputDateFormat, withTime) {
    return (0, react_1.useMemo)(function () {
        if (!(0, utils_1.isValidDate)(inputValue, inputDateFormat) ||
            (withTime && !(0, utils_1.isValidTime)(timeInputValue))) {
            if (withTime) {
                return inputValue || timeInputValue ? "".concat(inputValue, " ").concat(timeInputValue) : '';
            }
            return inputValue;
        }
        var mainValue = (0, utils_1.replaceFormat)(inputValue, inputDateFormat, mainInputDateFormat);
        if (withTime) {
            mainValue = (0, utils_1.setTime)(mainValue, timeInputValue, mainInputDateFormat, (0, utils_1.getTime)(value));
        }
        return mainValue;
    }, [inputValue, inputDateFormat, mainInputDateFormat, withTime, timeInputValue, value]);
}
function DateRangePicker(props) {
    var onBlur = props.onBlur, dateFrom = props.dateFrom, dateTo = props.dateTo, open = props.open, variant = props.variant, _a = props.popperOptions, popperOptions = _a === void 0 ? {
        modifiers: { flip: { enabled: false } },
    } : _a, _b = props.placement, placement = _b === void 0 ? 'bottom-start' : _b, placeholder = props.placeholder, label = props.label, disabled = props.disabled, error = props.error, helperText = props.helperText, dateFormat = props.dateFormat, _c = props.inputDateFormat, inputDateFormat = _c === void 0 ? 'L' : _c, withTime = props.withTime, classes = props.classes, className = props.className;
    var theme = (0, system_1.useTheme)();
    var _d = props.mainInputDateFormat, mainInputDateFormat = _d === void 0 ? withTime ? 'L LT' : 'L' : _d;
    var formHelperTextProps = (0, hooks_1.useHelperProps)(withTime);
    var _e = __read((0, hooks_1.usePopup)(), 3), inputRef = _e[0], paperRef = _e[1], anchorEl = _e[2];
    var inputFromRef = (0, react_1.useRef)();
    var inputToRef = (0, react_1.useRef)();
    var timeInputFromRef = (0, react_1.useRef)();
    var timeInputToRef = (0, react_1.useRef)();
    var calendarStyles = useCalendarStyles();
    var styles = useStyles({ withTime: withTime });
    var _f = __read((0, react_1.useState)(false), 2), focus = _f[0], setFocus = _f[1];
    var _g = __read((0, hooks_1.useTimeValue)(dateFrom.value, withTime), 2), timeFrom = _g[0], setTimeFrom = _g[1];
    var _h = __read((0, hooks_1.useTimeValue)(dateTo.value, withTime), 2), timeTo = _h[0], setTimeTo = _h[1];
    var _j = __read((0, hooks_1.useInputValue)(dateFrom.value, inputDateFormat, dateFormat), 3), inputFrom = _j[0], setInputFrom = _j[1], isValidInputFrom = _j[2];
    var _k = __read((0, hooks_1.useInputValue)(dateTo.value, inputDateFormat, dateFormat), 3), inputTo = _k[0], setInputTo = _k[1], isValidInputTo = _k[2];
    var _l = __read((0, hooks_1.useCalendarValue)({
        value: dateFrom.value,
        dateFormat: dateFormat,
    }), 2), calendarFrom = _l[0], setCalendarFrom = _l[1];
    var _m = __read((0, hooks_1.useCalendarValue)({
        value: dateTo.value,
        dateFormat: dateFormat,
    }), 2), calendarTo = _m[0], setCalendarTo = _m[1];
    var selectedRange = (0, react_1.useMemo)(function () { return [calendarFrom, calendarTo]; }, [
        calendarFrom,
        calendarTo,
    ]);
    var updateFromSafe = (0, react_1.useCallback)(function (value) {
        var _a, _b;
        (_a = dateFrom.onChange) === null || _a === void 0 ? void 0 : _a.call(dateFrom, value);
        var toValue = calendarTo;
        if (!toValue)
            return;
        if (withTime) {
            toValue = (0, utils_1.setTime)(toValue, timeTo, undefined, (0, utils_1.getTime)(dateTo.value));
        }
        if ((0, utils_1.isAfter)((0, utils_1.toISO)(value, dateFormat), toValue)) {
            setInputTo((0, utils_1.replaceFormat)(value, dateFormat, inputDateFormat));
            setCalendarTo((0, utils_1.toISO)(value, dateFormat));
            if (withTime) {
                setTimeTo((0, utils_1.getTime)(value, dateFormat));
            }
            (_b = dateTo.onChange) === null || _b === void 0 ? void 0 : _b.call(dateTo, value);
        }
    }, [
        dateFormat,
        dateFrom,
        dateTo,
        inputDateFormat,
        setTimeTo,
        setCalendarTo,
        setInputTo,
        timeTo,
        calendarTo,
        withTime,
    ]);
    var updateToSafe = (0, react_1.useCallback)(function (value) {
        var _a, _b;
        (_a = dateTo.onChange) === null || _a === void 0 ? void 0 : _a.call(dateTo, value);
        var fromValue = calendarFrom;
        if (!fromValue)
            return;
        if (withTime) {
            fromValue = (0, utils_1.setTime)(fromValue, timeFrom, undefined, (0, utils_1.getTime)(dateFrom.value));
        }
        if ((0, utils_1.isBefore)((0, utils_1.toISO)(value, dateFormat), fromValue)) {
            setInputFrom((0, utils_1.replaceFormat)(value, dateFormat, inputDateFormat));
            setCalendarFrom((0, utils_1.toISO)(value, dateFormat));
            if (withTime) {
                setTimeFrom((0, utils_1.getTime)(value, dateFormat));
            }
            (_b = dateFrom.onChange) === null || _b === void 0 ? void 0 : _b.call(dateFrom, value);
        }
    }, [
        dateFormat,
        dateFrom,
        dateTo,
        calendarFrom,
        inputDateFormat,
        setInputFrom,
        setTimeFrom,
        setCalendarFrom,
        timeFrom,
        withTime,
    ]);
    var fromUpdater = (0, hooks_1.useValueUpdater)({
        value: dateFrom.value,
        inputValue: inputFrom,
        inputDateFormat: inputDateFormat,
        dateFormat: dateFormat,
        withTime: withTime,
        timeInputValue: timeFrom,
        setCalendarValue: setCalendarFrom,
        onChange: updateFromSafe,
    });
    var toUpdater = (0, hooks_1.useValueUpdater)({
        value: dateTo.value,
        inputValue: inputTo,
        inputDateFormat: inputDateFormat,
        dateFormat: dateFormat,
        withTime: withTime,
        timeInputValue: timeTo,
        setCalendarValue: setCalendarTo,
        onChange: updateToSafe,
    });
    var _o = __read((0, hooks_1.useHandlers)({
        setInputValue: setInputFrom,
        setTimeInputValue: setTimeFrom,
        setCalendarValue: setCalendarFrom,
        onChange: dateFrom.onChange,
        updater: fromUpdater,
        inputDateFormat: inputDateFormat,
    }), 4), onClearFrom = _o[0], onDateFromChange = _o[1], onInputFromChange = _o[2], onTimeFromChange = _o[3];
    var _p = __read((0, hooks_1.useHandlers)({
        setInputValue: setInputTo,
        setTimeInputValue: setTimeTo,
        setCalendarValue: setCalendarTo,
        onChange: dateTo.onChange,
        updater: toUpdater,
        inputDateFormat: inputDateFormat,
    }), 4), onClearTo = _p[0], onDateToChange = _p[1], onInputToChange = _p[2], onTimeToChange = _p[3];
    var oneOfInputs = function (el) {
        var _a, _b, _c, _d;
        var result = el === inputFromRef.current ||
            el === inputToRef.current ||
            el === timeInputFromRef.current ||
            el === timeInputToRef.current ||
            ((_a = inputFromRef.current) === null || _a === void 0 ? void 0 : _a.contains(el)) ||
            ((_b = inputToRef.current) === null || _b === void 0 ? void 0 : _b.contains(el)) ||
            ((_c = timeInputFromRef.current) === null || _c === void 0 ? void 0 : _c.contains(el)) ||
            ((_d = timeInputToRef.current) === null || _d === void 0 ? void 0 : _d.contains(el));
        return result;
    };
    var onInputFocus = (0, react_1.useCallback)(function () {
        setFocus(true);
    }, [setFocus]);
    var onInputBlur = (0, react_1.useCallback)(function (e) {
        if (oneOfInputs(e.relatedTarget)) {
            return;
        }
        setFocus(false);
        if (!isValidInputFrom) {
            var newInputValue = (0, utils_2.formatInput)(dateFrom.value, inputDateFormat, dateFormat);
            setInputFrom(newInputValue);
            fromUpdater({ newInputValue: newInputValue });
        }
        if (!isValidInputTo) {
            var newInputValue = (0, utils_2.formatInput)(dateTo.value, inputDateFormat, dateFormat);
            setInputTo(newInputValue);
            toUpdater({ newInputValue: newInputValue });
        }
        if (!(0, utils_1.isValidTime)(timeFrom)) {
            setTimeFrom((0, utils_1.getTime)(dateFrom.value));
        }
        if (!(0, utils_1.isValidTime)(timeTo)) {
            setTimeTo((0, utils_1.getTime)(dateTo.value));
        }
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [
        isValidInputFrom,
        isValidInputTo,
        timeFrom,
        timeTo,
        onBlur,
        dateFrom.value,
        inputDateFormat,
        dateFormat,
        setInputFrom,
        fromUpdater,
        dateTo.value,
        setInputTo,
        toUpdater,
        setTimeFrom,
        setTimeTo,
    ]);
    var preventBlur = (0, react_1.useCallback)(function (e) {
        if (oneOfInputs(e.currentTarget) || oneOfInputs(e.target)) {
            return;
        }
        e.preventDefault();
    }, []);
    var fromMainValue = useMainValue(dateFrom.value, inputFrom, timeFrom, inputDateFormat, mainInputDateFormat, withTime);
    var toMainValue = useMainValue(dateTo.value, inputTo, timeTo, inputDateFormat, mainInputDateFormat, withTime);
    var mainInputValue = fromMainValue || toMainValue ? "".concat(fromMainValue, " - ").concat(toMainValue) : '';
    var isBeforeDisabled = (0, react_1.useCallback)(function (date) {
        return !!selectedRange[1] && (0, utils_1.isAfter)(date, selectedRange[1], 'day');
    }, [selectedRange]);
    var isAfterDisabled = (0, react_1.useCallback)(function (date) {
        return !!selectedRange[0] && (0, utils_1.isBefore)(date, selectedRange[0], 'day');
    }, [selectedRange]);
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(styles.root, classes === null || classes === void 0 ? void 0 : classes.root, className), onFocus: onInputFocus, onBlur: onInputBlur },
        react_1.default.createElement(Input_1.Input, { className: (0, utils_1.cn)(styles.input, classes === null || classes === void 0 ? void 0 : classes.input), ref: inputRef, value: mainInputValue, variant: variant, iconStart: react_1.default.createElement(icons_1.CalendarIcon, { className: styles.calendarIcon }), placeholder: placeholder, label: label, disabled: disabled, error: error, helperText: helperText, clearable: false }),
        react_1.default.createElement(Popper_1.default, __assign({}, popperOptions, { open: !disabled && (!!open || focus) && !!anchorEl, anchorEl: anchorEl, placement: placement, className: classes === null || classes === void 0 ? void 0 : classes.popper, disablePortal: true }),
            react_1.default.createElement("div", { ref: paperRef, className: (0, utils_1.cn)(styles.paper, classes === null || classes === void 0 ? void 0 : classes.paper), onMouseDown: preventBlur, dir: theme.direction },
                react_1.default.createElement("div", { className: styles.calendarsGroup },
                    react_1.default.createElement(Calendar_1.Calendar, { value: calendarFrom, selectedRange: selectedRange, classes: calendarStyles, onDayClick: onDateFromChange, isDisabledDate: isBeforeDisabled }),
                    react_1.default.createElement(Calendar_1.Calendar, { value: calendarTo, selectedRange: selectedRange, classes: calendarStyles, onDayClick: onDateToChange, isDisabledDate: isAfterDisabled })),
                react_1.default.createElement("div", { className: styles.inputsGroup },
                    react_1.default.createElement(Input_1.Input, { className: styles.dateInput, ref: inputFromRef, variant: variant, value: inputFrom, onClear: onClearFrom, onChange: onInputFromChange, placeholder: dateFrom.placeholder, error: dateFrom.error, helperText: dateFrom.helperText, onBlur: dateFrom.onBlur, FormHelperTextProps: formHelperTextProps }),
                    withTime && (react_1.default.createElement(Input_1.Input, { ref: timeInputFromRef, className: (0, utils_1.cn)(styles.timeInput, classes === null || classes === void 0 ? void 0 : classes.timeInput), value: timeFrom, variant: variant, placeholder: "00:00", disabled: disabled, error: dateFrom.error, onBlur: dateFrom.onBlur, onChange: onTimeFromChange, clearable: false })),
                    react_1.default.createElement("span", { className: styles.dash }, "\u2014"),
                    react_1.default.createElement(Input_1.Input, { ref: inputToRef, className: styles.dateInput, variant: variant, value: inputTo, onClear: onClearTo, onBlur: dateTo.onBlur, onChange: onInputToChange, placeholder: dateTo.placeholder, error: dateTo.error, helperText: dateTo.helperText, FormHelperTextProps: formHelperTextProps }),
                    withTime && (react_1.default.createElement(Input_1.Input, { ref: timeInputToRef, className: (0, utils_1.cn)(styles.timeInput, classes === null || classes === void 0 ? void 0 : classes.timeInput), value: timeTo, variant: variant, placeholder: "00:00", disabled: disabled, error: dateTo.error, onBlur: dateTo.onBlur, onChange: onTimeToChange, clearable: false })))))));
}
exports.DateRangePicker = DateRangePicker;
